import { render, staticRenderFns } from "./AtomOption.vue?vue&type=template&id=36b07ad2&"
import script from "./AtomOption.vue?vue&type=script&lang=js&"
export * from "./AtomOption.vue?vue&type=script&lang=js&"
import style0 from "./AtomOption.vue?vue&type=style&index=0&id=36b07ad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
